import lfRequest from '@/service/index'

export function listWithEmp() {
  return lfRequest.get<any[]>({
    url: `/main/dept/listWithEmp`
  })
}
